import footerBG from './assets/video/footerBG.mp4';
import { format, formatRelative } from 'date-fns';

const Footer = () => {
  const lastUpdate = new Date('2026-02-21');
  return (
    <div className='footerContainer'>
      <video className='videoBG' autoPlay muted loop preload='auto'>
        <source type='video/mp4' src={footerBG} />
      </video>
      <div className='footerItems'>
        <h2>Crystall - project </h2>
        <p>
          Contact: <br />
          <a
            className='contactLink'
            target='blank'
            href='https://www.linkedin.com/in/lanakorolkova/'
          >
            linkedIn profile
          </a>
        </p>
        <p>
          Last update:
          {formatRelative(lastUpdate, new Date())}
        </p>
      </div>
    </div>
  );
};

export default Footer;
